<template>
  <div class="d-inline">
    <span class="last-seen-text text-ellipsis" v-if="params.lastLocationTime">{{ params.lastLocationTime | moment('MM/DD/YYYY hh:mm A') }}</span>
    <span class="last-seen-text text-ellipsis" v-else>--</span>
  </div>
</template>

<script>
export default {
  props: ['params'],
};
</script>

<style lang="scss" scoped>
  .last-seen-text {
    min-width: 140px;
  }
</style>
